import { EventPhaseStatus } from "./event.model";

export interface PayloadEventDetail {
    pageNumber: number;
    pageSize: number;
    status: EventPhaseStatus;
}